import HomeFooter from '../HomeFooter';
import { Box, Flex, List, Text } from '@chakra-ui/react';
import { formatDocumentTitle } from '../../../utils/documentTitle';
import { NavLink } from 'react-router-dom';

export function UnderageProtectionPage() {
    document.title = formatDocumentTitle('Ochrona małoletnich');
    return (
        <Flex direction='column' h="100%" w="100vw">
            <Box
                flexGrow='1'
                overflow="scroll"
                p="8"
            >
                <Text as='h2' fontSize='2xl' fontWeight='bold' mb={4}>
                    Polityka Ochrony Dzieci przed Krzywdzeniem Centrum Korepetycji Opanuj.to
                </Text>

                <List.Root as="ol" pl={6} mb={4}>
                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Definicje</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Osoba Odpowiedzialna za Politykę – Dominik Soszyński, odpowiedzialny za wdrożenie oraz monitorowanie polityki.</List.Item>
                            <List.Item mb={2}>Organizator – Centrum Korepetycji Opanuj.to.</List.Item>
                            <List.Item mb={2}>Opiekun Prawny – rodzic lub inna osoba uprawniona do reprezentacji dziecka.</List.Item>
                            <List.Item mb={2}>Dziecko – osoba, która nie ukończyła 18. roku życia.</List.Item>
                            <List.Item mb={2}>Członek Personelu – pracownik Centrum Korepetycji Opanuj.to.</List.Item>
                            <List.Item mb={2}>Koordynator Bezpieczeństwa Dzieci – Paulina Kaczyńska.</List.Item>
                            <List.Item mb={2}>Zgoda Rodzica – zgoda co najmniej jednego z rodziców/opiekunów prawnych dziecka.</List.Item>
                            <List.Item mb={2}>Krzywdzenie Dziecka – wszelkie działania zabronione prawem, które zagrażają dobru dziecka, w tym zaniedbanie.</List.Item>
                            <List.Item mb={2}>Przemoc Fizyczna – działanie mogące prowadzić do uszczerbku na zdrowiu fizycznym dziecka.</List.Item>
                            <List.Item mb={2}>Przemoc Psychiczna – działania negatywnie wpływające na stan emocjonalny dziecka, takie jak poniżanie, zastraszanie czy izolowanie.</List.Item>
                            <List.Item mb={2}>Przemoc Seksualna – wszelkie zachowania o charakterze seksualnym wobec dziecka, w tym nieodpowiednie dotykanie czy przemoc seksualna.</List.Item>
                            <List.Item mb={2}>Dane Osobowe Dziecka – informacje umożliwiające identyfikację dziecka.</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Identyfikacja Ryzyka i Symptomów Krzywdzenia Dzieci</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Członkowie personelu są zobowiązani do reagowania na wszelkie sygnały wskazujące na możliwe krzywdzenie dziecka, obserwując jego zachowanie oraz stan emocjonalny.</List.Item>
                            <List.Item mb={2}>Personel musi przestrzegać zasad bezpiecznego kontaktu z dziećmi.</List.Item>
                            <List.Item>Rekrutacja personelu zgodna będzie z zasadami bezpiecznej rekrutacji.</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Procedury Interwencji w Przypadku Podejrzeń Krzywdzenia Dziecka</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>W razie podejrzenia krzywdzenia dziecka, członek personelu ma obowiązek powiadomić opiekuna prawnego dziecka oraz sporządzić notatkę na karcie interwencji, którą przekazuje Koordynatorowi Bezpieczeństwa Dzieci.</List.Item>
                            <List.Item mb={2}>Koordynator informuje personel o obowiązku zgłaszania interwencji do odpowiednich instytucji (prokuratura, policja, sąd rodzinny).</List.Item>
                            <List.Item mb={2}>Koordynator weryfikuje zgłoszenia i ma obowiązek powiadomić odpowiednie służby, gdy uzyska informację o zagrożeniu.</List.Item>
                            <List.Item mb={2}>Koordynator prowadzi rejestr kart interwencji.</List.Item>
                            <List.Item>W razie wątpliwości co do postępowania, członek personelu powinien skontaktować się z Koordynatorem.</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Krzywdzenie Dziecka przez Osobę Dorosłą</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Po zgłoszeniu krzywdzenia przez osobę dorosłą, Koordynator kontaktuje się z opiekunem prawnym i dokumentuje sytuację.</List.Item>
                            <List.Item mb={2}>W przypadku podejrzenia, że przestępstwo miało miejsce, członek personelu przygotowuje oficjalne zawiadomienie do policji.</List.Item>
                            <List.Item mb={2}>Gdy opiekunowie nie są zainteresowani pomocą, Koordynator składa wniosek do sądu rodzinnego.</List.Item>
                            <List.Item mb={2}>Członek personelu podejrzewany o krzywdzenie dziecka zostaje natychmiastowo odsunięty od pracy z dziećmi.</List.Item>
                            <List.Item mb={2}>W przypadku podejrzeń o inne formy krzywdzenia, Koordynator zbiera informacje i podejmuje decyzję o dalszym postępowaniu.</List.Item>
                            <List.Item>W sytuacji bezpośredniego zagrożenia zdrowia lub życia dziecka, personel wzywa służby ratunkowe (112 lub 999).</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Postępowanie w Przypadku Krzywdzenia Rówieśniczego</Text>
                        <Text mb="4">W przypadku krzywdzenia dziecka przez inne dziecko, należy przeprowadzić rozmowę z opiekunami prawnymi.</Text>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Zasady Ochrony Prywatności i Wizerunku Dziecka</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Organizator zapewnia ochronę danych osobowych dzieci zgodnie z obowiązującymi przepisami.</List.Item>
                            <List.Item>Organizator stosuje środki zabezpieczające wizerunek dziecka z poszanowaniem jego prywatności.</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Monitoring i Ocena Polityki</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Dominik Soszyński został wyznaczony na Osobę Odpowiedzialną za Politykę Ochrony Dzieci.</List.Item>
                            <List.Item mb={2}>Monitorowanie polityki i współpraca z Koordynatorem to obowiązki Osoby Odpowiedzialnej za politykę.</List.Item>
                            <List.Item mb={2}>Koordynator składa sprawozdania Osobie Odpowiedzialnej.</List.Item>
                            <List.Item mb={2}>Członkowie personelu mogą zgłaszać propozycje zmian w polityce oraz wskazywać naruszenia.</List.Item>
                            <List.Item>Na podstawie sprawozdania, Organizator wprowadza modyfikacje do polityki.</List.Item>
                        </List.Root>
                    </List.Item>

                    <List.Item mt="4" mb={2}>
                        <Text fontWeight="bold">Postanowienia Końcowe</Text>
                        <List.Root as="ol" pl={6} mb={4}>
                            <List.Item mb={2}>Polityka wchodzi w życie z chwilą publikacji na stronie internetowej Opanuj.to.</List.Item>
                            <List.Item mb={2}>Polityka jest dostępna dla wszystkich zainteresowanych na stronie internetowej.</List.Item>
                            <List.Item mb={2}>Członkowie personelu zobowiązani są do zapoznania się z polityką oraz do jej przestrzegania.</List.Item>
                            <List.Item>
                                Do polityki dołączone są następujące załączniki:
                                <List.Root as="ul" pl={6} mt={2}>
                                    <List.Item>
                                        Załącznik nr 1 -{' '}
                                        <NavLink
                                            to="/static/assets/Karta-interwencji.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: '#f97316', textDecoration: 'underline' }}
                                        >
                                            Karta interwencji
                                        </NavLink>
                                    </List.Item>
                                    <List.Item>
                                        Załącznik nr 2 -{' '}
                                        <NavLink
                                            to="/static/assets/Oswiadczenie-o-zapoznaniu-z-Polityka-ochrony-Dziecka.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ color: '#f97316', textDecoration: 'underline' }}
                                        >
                                            Oświadczenie o zapoznaniu z Polityką ochrony Dziecka
                                        </NavLink>
                                    </List.Item>
                                </List.Root>
                            </List.Item>
                        </List.Root>
                    </List.Item>
                </List.Root>

                <HomeFooter />
            </Box>
        </Flex>
    );
}
